import {
  IGetPromoDeductionApplySummaryParams,
  IPromotionRepository,
  IPromoDeductionApplySummaryResponse,
} from "@/core/repositories/promotion";

export class GetPromoDeductionApplySummaryUseCase {
  constructor(private readonly repo: IPromotionRepository) {}

  async execute(
    params: IGetPromoDeductionApplySummaryParams,
    refetch = false
  ): Promise<IPromoDeductionApplySummaryResponse> {
    return this.repo.getPromoDeductionApplySummary(params, refetch);
  }
}
